import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  actionIcon,
  alerts,
  appReports,
  convertToNumber,
  documentManagement,
  helpTooltip,
} from 'app/components/global';
import editAuditDialog from './dialog.editAuditDialog';
import settingsDialog from './dialog.settingsDialog';
import audits from './audits';
import controller from './audit-trail.controller';


export const routeConfig = {
  template: require('./audit-trail.html'),
  controller: 'AuditTrailController',
  controllerAs: 'auditTrailVM',
};

export default angular.module('app.components.advisory.auditTrail', [
  actionIcon,
  alerts,
  amDataService,
  amSharedModelService,
  appReports,
  audits,
  constants,
  convertToNumber,
  documentManagement,
  editAuditDialog,
  helpTooltip,
  loaderService,
  orgDataService,
  settingsDialog,
  ssDialogService,
  userService,
])
  .controller('AuditTrailController', controller)
  .name;

console.log('app.components.advisory.auditTrail created');
